import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  Button,
  Tooltip,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Typography,
  Autocomplete,
} from "@mui/material";
import { DataGrid, Toolbar, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import invoiceConfigApi from "../api/invoiceConfigApi";
import supplierApi from "../api/supplierApi";
import invoiceSupplierConfigApi from "../api/invoiceSupplierConfigApi";

import ConfirmDialog from "../components/ConfirmDialog";

const theme = createTheme({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          "& .MuiCheckbox-root": {
            padding: 6,
          },
        },
      },
    },
  },
});

const pageNo = "DataConfigPage";
function DataConfigPage() {
  const user = useSelector((state) => state.auth.user);
  const customerInfor = useSelector((state) => state.auth.customerInfor);
  const roles = useSelector((state) => state.auth.roles);
  const [invoiceConfig, setInvoiceConfig] = useState({
    CusId: customerInfor?.CusId,
    IcIssueTaxAuthorityCode: 1,
    IcIssueInvoiceNumber: 1,
    IcIsSyncSufficientInfor: false,
    IcSyncWhenAccountingPerform: false,
    IcIsSyncEndDay: false,
    IcDefaultBuyerName: false,
    IcSyncAndSignSame: false,
    IcSyncWhenEnterDataFromQR: false,
    IcSignAllInvoice: false,
    IcSignAsSoonAsSync: false,
    icBuyerDefaultName: "",
    ic_is_sync_content_to_supplier: false,
    ic_is_sync_note_to_supplier: false,
  });
  const icBuyerDefaultNameRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [openEditConfigModal, setOpenEditConfigModal] = useState(false);
  const [selectedSupplierConfig, setSelectedSupplierConfig] = useState(null);
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [loadingSuppliers, setLoadingSuppliers] = useState(false);
  const [eInvoiceConfigData, setEInvoiceConfigData] = useState({});
  const [eInvoiceConfigFields, setEInvoiceConfigFields] = useState([]);
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);
  const [currentIscId, setCurrentIscId] = useState(null);
  const [loadingInvoiceSupplierConfig, setLoadingInvoiceSupplierConfig] =
    useState(false);
  const [invoiceSupplierConfigs, setInvoiceSupplierConfigs] = useState([]);
  const [iscBeginNumCQT, setIscBeginNumCQT] = useState(0);
  const [iscDescription, setIscDescription] = useState("");
  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: () => {},
    onClose: () => {},
  });
  const fetchInvoiceSupplierConfig = useCallback(async (CusId) => {
    setLoadingInvoiceSupplierConfig(true);
    try {
      const response =
        await invoiceSupplierConfigApi.SearchInvoiceSupplierConfig(CusId);
      if (response.success) {
        setInvoiceSupplierConfigs(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu");
      console.error(error);
    } finally {
      setLoadingInvoiceSupplierConfig(false);
    }
  }, []);
  useEffect(() => {
    fetchInvoiceSupplierConfig(customerInfor?.CusId);
  }, [fetchInvoiceSupplierConfig, customerInfor?.CusId]);

  const handleDeleteInvoiceSupplierConfig = async (IscId) => {
    try {
      const response =
        await invoiceSupplierConfigApi.DeleteInvoiceSupplierConfig(IscId);

      if (response.success) {
        setConfirmDialogState({
          ...confirmDialogState,
          open: false,
        });
        const response1 =
          await invoiceSupplierConfigApi.SearchInvoiceSupplierConfig(
            customerInfor?.CusId,
          );
        if (response1.success) {
          setInvoiceSupplierConfigs(response1.data);
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu");
      console.error(error);
    }
  };
  const handleChooseInvoiceSupplierConfig = async (IscId) => {
    try {
      const response =
        await invoiceSupplierConfigApi.ChooseInvoiceSupplierConfig(IscId);
      if (response.success) {
        const response1 =
          await invoiceSupplierConfigApi.SearchInvoiceSupplierConfig(
            customerInfor?.CusId,
          );
        if (response1.success) {
          setInvoiceSupplierConfigs(response1.data);
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Lỗi xử lý dữ liệu");
      console.error(error);
    }
  };

  const CustomToolbar = () => {
    return (
      <Toolbar sx={{ minHeight: 40 }}>
        <Grid sx={{ flex: "1 1 100%", marginLeft: "10px", display: "flex" }}>
          <Typography variant="h6">Nhà cung cấp hóa đơn</Typography>
          {user.UsEmail === "admini" && (
            <Typography
              variant="h7"
              sx={{ ml: 2, alignContent: "end", mb: 0.5 }}
            >
              <i
                style={{
                  textDecoration: "underline",
                  color: "#1976d2",
                  cursor: "pointer",
                }}
                onClick={() => handleEditInvoiceSupplierConfig(null)}
              >
                Thêm kết nối nhà cung cấp hóa đơn
              </i>
            </Typography>
          )}
          {user.UsEmail !== "admini" && (
            <Typography variant="h6" sx={{ color: "red", ml: 2 }}>
              Vui lòng liên hệ Relisoft để thay đổi cấu hình
            </Typography>
          )}
        </Grid>

        <Tooltip title="Tìm kiếm">
          <GridToolbarQuickFilter />
        </Tooltip>
      </Toolbar>
    );
  };

  const handleEditInvoiceSupplierConfig = async (IscId) => {
    setCurrentIscId(IscId);
    setSelectedSupplierConfig(null);
    setEInvoiceConfigData({});
    setEInvoiceConfigFields([]);

    setIsLoadingConfig(true);
    console.log(IscId);
    if (IscId) {
      try {
        const configResponse =
          await invoiceSupplierConfigApi.GetInvoiceSupplierConfig(IscId);
        if (configResponse.success && configResponse.data) {
          setIscBeginNumCQT(configResponse.data.IscBeginNumCQT);
          setIscDescription(configResponse.data.IscDescription);
          setEInvoiceConfigData(configResponse.data.IscConfigs || {});
          setEInvoiceConfigFields(configResponse.data.EsExtendProperties);
          console.log(configResponse.data.EsExtendProperties);

          const existingSupplier = allSuppliers.find(
            (sup) => sup.id === configResponse.data.EsId,
          );
          if (existingSupplier) {
            setSelectedSupplierConfig({
              ...existingSupplier,
              EsExtendProperties: configResponse.data.EsExtendProperties,
            });
          } else if (configResponse.data.EsId && configResponse.data.EsName) {
            setSelectedSupplierConfig({
              id: configResponse.data.EsId,
              name: configResponse.data.EsName,
              EsExtendProperties: configResponse.data.EsExtendProperties,
            });
          }
        }
      } catch (error) {
        console.error("Lỗi khi tải cấu hình hóa đơn điện tử:", error);
        toast.error(
          error.toString() || "Đã xảy ra lỗi khi tải cấu hình hóa đơn điện tử.",
        );
      } finally {
      }
    }

    setOpenEditConfigModal(true);
    setIsLoadingConfig(false);
  };
  const handleEInvoiceConfigChange = useCallback((parameterName, value) => {
    setEInvoiceConfigData((prev) => ({
      ...prev,
      [parameterName]: value,
    }));
  }, []);

  const handleSaveSupplierConfigEInvoice = async () => {
    if (!selectedSupplierConfig) {
      toast.warning("Vui lòng chọn nhà cung cấp hóa đơn điện tử.");
      return;
    }
    for (const field of eInvoiceConfigFields) {
      if (
        field.isRequired &&
        !eInvoiceConfigData[field.parameterName] &&
        !field.isHidden
      ) {
        toast.warning(`Vui lòng nhập "${field.fieldName}"`);
        return;
      }
      if (field.isHidden)
        eInvoiceConfigData[field.parameterName] = field.defaultValue;
    }

    setLoading(true);
    try {
      const response =
        await invoiceSupplierConfigApi.UpsertInvoiceSupplierConfig({
          IscId: currentIscId,
          CusId: customerInfor?.CusId,
          EsId: selectedSupplierConfig.id,
          IscConfigs: eInvoiceConfigData,
          IscBeginNumCQT: iscBeginNumCQT,
          IscDescription: iscDescription,
        });
      if (response.success) {
        toast.success(
          response.message || "Cập nhật cấu hình hóa đơn điện tử thành công!",
        );
        handleCloseConfigEInvoice();
        setIscBeginNumCQT(0);
        setIscDescription("");
      } else {
        toast.error(
          response.message || "Cập nhật cấu hình hóa đơn điện tử thất bại.",
        );
      }
    } catch (error) {
      console.error("Lỗi khi lưu cấu hình hóa đơn điện tử:", error);
      toast.error("Đã xảy ra lỗi khi lưu cấu hình hóa đơn điện tử.");
    } finally {
      setLoading(false);
    }
  };
  const handleCloseConfigEInvoice = () => {
    setOpenEditConfigModal(false);
    setSelectedSupplierConfig(null);
    setIscBeginNumCQT(0);
    setIscDescription("");
    setEInvoiceConfigData({});
    setEInvoiceConfigFields([]);
    fetchInvoiceSupplierConfig(customerInfor?.CusId);
  };
  const fetchSuppliersForAutocomplete = useCallback(async () => {
    setLoadingSuppliers(true);
    try {
      const response = await supplierApi.getSupplier();
      if (response.success && response.data) {
        setAllSuppliers(
          response.data.map((sup) => ({
            id: sup.EsId,
            name: sup.EsName,
            EsExtendProperties: sup.EsExtendProperties,
          })),
        );
      } else {
        toast.error(
          response.message || "Không thể tải danh sách nhà cung cấp.",
        );
      }
    } catch (error) {
      toast.error(
        error.toString() || "Lỗi kết nối khi tải danh sách nhà cung cấp.",
      );
    } finally {
      setLoadingSuppliers(false);
    }
  }, []);

  const selectedSupplierConfigOnChange = (newValue) => {
    if (newValue && newValue.id) {
      const fullSupplierData = allSuppliers.find(
        (sup) => sup.id === newValue.id,
      );

      if (fullSupplierData && fullSupplierData.EsExtendProperties) {
        setEInvoiceConfigFields(fullSupplierData.EsExtendProperties);
        setEInvoiceConfigData((prevConfigData) => {
          const updatedConfigData = {};
          fullSupplierData.EsExtendProperties.forEach((field) => {
            updatedConfigData[field.parameterName] =
              prevConfigData[field.parameterName] !== undefined
                ? prevConfigData[field.parameterName]
                : "";
          });
          return updatedConfigData;
        });
      } else {
        setEInvoiceConfigFields([]);
        setEInvoiceConfigData({});
      }
    } else {
      setEInvoiceConfigFields([]);
      setEInvoiceConfigData({});
    }
  };

  const fetchInvoiceConfig = useCallback(async () => {
    try {
      setLoading(true);
      const response = await invoiceConfigApi.GetInvoiceConfig(
        customerInfor?.CusId,
      );
      if (response.success) {
        setInvoiceConfig(response.data);
        icBuyerDefaultNameRef.current.value =
          response.data.ic_buyer_default_name || "";
      } else toast.error(response.message);
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  }, [customerInfor?.CusId]);

  const handleSaveConfigEInvoice = async () => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo && x.CtrNo === "btnEdit" && x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền sửa cấu hình dữ liệu.");
      return;
    }
    try {
      let data = {
        CusId: customerInfor?.CusId,
        IcIssueTaxAuthorityCode: invoiceConfig.IcIssueTaxAuthorityCode,
        IcIssueInvoiceNumber: invoiceConfig.IcIssueInvoiceNumber,
        IcIsSyncSufficientInfor: invoiceConfig.IcIsSyncSufficientInfor,
        IcSyncWhenAccountingPerform: invoiceConfig.IcSyncWhenAccountingPerform,
        IcIsSyncEndDay: invoiceConfig.IcIsSyncEndDay,
        IcDefaultBuyerName: invoiceConfig.IcDefaultBuyerName,
        IcSyncAndSignSame: invoiceConfig.IcSyncAndSignSame,
        IcSyncWhenEnterDataFromQR: invoiceConfig.IcSyncWhenEnterDataFromQR,
        IcSignAllInvoice: invoiceConfig.IcSignAllInvoice,
        IcSignAsSoonAsSync: invoiceConfig.IcSignAsSoonAsSync,
        ic_buyer_default_name: invoiceConfig.ic_buyer_default_name,
        ic_is_sync_content_to_supplier:
          invoiceConfig.ic_is_sync_content_to_supplier,
        ic_is_sync_note_to_supplier: invoiceConfig.ic_is_sync_note_to_supplier,
      };
      if (icBuyerDefaultNameRef.current) {
        data.ic_buyer_default_name = icBuyerDefaultNameRef.current?.value;
      }
      const response = await invoiceConfigApi.UpsertInvoiceConfig(data);
      if (response.success) {
        toast.success(response.message || "Cập nhật cấu hình thành công!");
      } else {
        toast.error(response.message || "Cập nhật cấu hình thất bại.");
      }
    } catch (error) {
      console.error("Lỗi khi lưu cấu hình:", error);
      toast.error("Đã xảy ra lỗi khi lưu cấu hình.");
    } finally {
    }
  };

  useEffect(() => {
    fetchInvoiceConfig();
  }, [fetchInvoiceConfig]);
  const invoiceConfigSupplierColumns = [
    {
      field: "EsName",
      headerName: "Nhà cung cấp",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "IscIsActive",
      headerName: "Kích hoạt",
      headerAlign: "center",
      type: "boolean",
      width: 120,
    },
    {
      field: "IscBeginNumCQT",
      headerName: "Số bắt đầu Mã CQT >",
      headerAlign: "center",
      align: "center",
      width: 160,
    },
    {
      field: "actions",
      headerName: "Thiết lập kết nối",
      headerAlign: "center",
      type: "actions",
      width: 180,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        user.UsEmail === "admini" ? (
          <Box sx={{ display: "flex" }}>
            <Typography>
              <i
                style={{
                  textDecoration: "underline",
                  color: "#1976d2",
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleEditInvoiceSupplierConfig(params.row.IscId)
                }
              >
                Sửa
              </i>
            </Typography>
            <Typography>
              <i> - </i>
            </Typography>
            <Typography>
              <i
                style={{
                  textDecoration: "underline",
                  color: "#1976d2",
                  cursor: "pointer",
                }}
                onClick={() =>
                  setConfirmDialogState({
                    open: true,
                    title: "Xoá cấu hình",
                    content: "Bạn có chắc muốn xoá cấu hình hoá đơn này?",
                    onConfirm: () =>
                      handleDeleteInvoiceSupplierConfig(params.row.IscId),
                    onClose: () =>
                      setConfirmDialogState({
                        ...confirmDialogState,
                        open: false,
                      }),
                  })
                }
              >
                Xóa
              </i>
            </Typography>
            {params.row.IscIsActive === false && (
              <>
                <Typography>
                  <i> - </i>
                </Typography>
                <Typography>
                  <i
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleChooseInvoiceSupplierConfig(params.row.IscId)
                    }
                  >
                    Kích hoạt
                  </i>
                </Typography>
              </>
            )}
          </Box>
        ) : (
          <></>
        ),
    },
    {
      field: "IscCreateDate",
      headerName: "Ngày tạo",
      headerAlign: "center",
      align: "center",
      width: 150,
      valueFormatter: (params) => {
        return params ? dayjs(params).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "IscUpdateDate",
      headerName: "Ngày cập nhật",
      headerAlign: "center",
      align: "center",
      width: 150,
      valueFormatter: (params) => {
        return params ? dayjs(params).format("DD/MM/YYYY") : "";
      },
    },
    {
      field: "UsFullNameCreate",
      headerName: "Người tạo",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
    {
      field: "UsFullNameApprove",
      headerName: "Người duyệt",
      headerAlign: "center",
      align: "center",
      width: 150,
    },
  ];
  useEffect(() => {
    fetchSuppliersForAutocomplete();
  }, [fetchSuppliersForAutocomplete]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{ p: 1, flexGrow: 1, display: "flex", flexDirection: "column" }}
        >
          {loading ? (
            <p>Đang tải cấu hình...</p>
          ) : (
            <Container maxWidth="xxl">
              <Grid>
                <DataGrid
                  rows={invoiceSupplierConfigs}
                  columns={invoiceConfigSupplierColumns}
                  loading={loadingInvoiceSupplierConfig}
                  getRowId={(row) => row.IscId}
                  columnHeaderHeight={40}
                  rowHeight={32}
                  showCellVerticalBorder
                  showColumnVerticalBorder
                  slots={{
                    toolbar: CustomToolbar,
                  }}
                  showToolbar
                  hideFooter
                  sx={{
                    maxHeight: 175,
                    overflow: "auto",
                  }}
                />
              </Grid>
              <Grid sx={{ display: "flex", flexDirection: "row", mt: 1 }}>
                <Grid
                  sx={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography variant="h6">Mã cơ quan thuế</Typography>
                      <Typography sx={{ ml: 2, alignContent: "end", mb: 0.3 }}>
                        <i>chọn 1 trong 3</i>
                      </Typography>
                    </Grid>
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcIssueTaxAuthorityCode === 1}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcIssueTaxAuthorityCode: 1,
                            }))
                          }
                        />
                      }
                      label="Máy tính tiền cấp mã cơ quan thuế khi có thông tin"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcIssueTaxAuthorityCode === 2}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcIssueTaxAuthorityCode: 2,
                            }))
                          }
                        />
                      }
                      label="Máy tính tiền cấp mã cơ quan thuế khi kết thúc đơn hàng (dù chưa có thông tin xuất hóa đơn)"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcIssueTaxAuthorityCode === 3}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcIssueTaxAuthorityCode: 3,
                            }))
                          }
                        />
                      }
                      label="Nhận mã cơ quan thuế từ tổ chức truyền nhận"
                      size="small"
                    />
                  </Grid>
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography variant="h6">Số hóa đơn</Typography>
                      <Typography sx={{ ml: 2, alignContent: "end", mb: 0.3 }}>
                        <i>chọn 1 trong 2</i>
                      </Typography>
                    </Grid>
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcIssueInvoiceNumber === 1}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcIssueInvoiceNumber: 1,
                            }))
                          }
                        />
                      }
                      label="Số hóa đơn do tổ chức truyền nhận cấp số"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcIssueInvoiceNumber === 2}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcIssueInvoiceNumber: 2,
                            }))
                          }
                        />
                      }
                      label="Số hóa đơn: Hub quản lý thuế cấp số theo thứ tự cùng lúc với Mã CQT"
                      size="small"
                    />
                  </Grid>
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography variant="h6">Đồng bộ hóa đơn</Typography>
                      <Typography sx={{ ml: 2, alignContent: "end", mb: 0.3 }}>
                        <i>chọn đồng thời các lựa chọn</i>
                      </Typography>
                    </Grid>
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcIsSyncSufficientInfor}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcIsSyncSufficientInfor: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Đồng bộ hóa đơn khi có thông tin xuất hóa đơn"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcSyncWhenAccountingPerform}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcSyncWhenAccountingPerform: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Đồng bộ lên hóa đơn khi và chỉ khi kế toán đã kiểm tra và nhấn nút Đồng bộ"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcIsSyncEndDay}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcIsSyncEndDay: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Đồng bộ hóa đơn khi có thông tin tự động vào cuối ngày lúc 23:30 và vào lúc 04:00 ngày hôm sau"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcDefaultBuyerName}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcDefaultBuyerName: e.target.checked,
                            }))
                          }
                        />
                      }
                      label='Phiếu tính tiền (Bill) không có thông tin xhđ, đồng bộ tay trên hub sẽ mặc định là khách lẻ "Người mua không cung cấp thông tin"'
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcSyncAndSignSame}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcSyncAndSignSame: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Đồng bộ và phát hành hóa đơn cùng lúc (Misa, EasyInvoice_V2)"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcSyncWhenEnterDataFromQR}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcSyncWhenEnterDataFromQR: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Đồng bộ ngay nếu khách tự nhập thông tin xuất hóa đơn qua QR"
                      size="small"
                    />
                  </Grid>
                </Grid>
                <Grid
                  sx={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography variant="h6">Ký số phát hành</Typography>
                      <Typography sx={{ ml: 2, alignContent: "end", mb: 0.3 }}>
                        <i>
                          mặc định kế toán sẽ ký hóa đơn bên tổ chức truyền nhận
                        </i>
                      </Typography>
                    </Grid>
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcSignAllInvoice}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcSignAllInvoice: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Hiện chức năng ký phát hành tất cả hóa đơn đã đồng bộ (chỉ một số NCC hóa đơn cho phép)"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.IcSignAsSoonAsSync}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              IcSignAsSoonAsSync: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Ký số phát hành ngay khi đồng bộ (chỉ một số NCC hóa đơn cho phép)"
                      size="small"
                    />
                  </Grid>
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography variant="h6">Khách lẻ</Typography>
                    </Grid>
                    <TextField
                      sx={{ ml: 2, mt: 1 }}
                      label='Tên khách lẻ (mặc định "Người mua không cung cấp thông tin")'
                      inputRef={icBuyerDefaultNameRef}
                      defaultValue={invoiceConfig?.ic_buyer_default_name || ""}
                      size="small"
                    />
                  </Grid>
                  <Grid sx={{ display: "flex", flexDirection: "column" }}>
                    <Grid sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography variant="h6">Ghi chú</Typography>
                    </Grid>
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={
                            invoiceConfig?.ic_is_sync_content_to_supplier
                          }
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              ic_is_sync_content_to_supplier: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Đẩy ghi chú qua nhà cung cấp hóa đơn"
                      size="small"
                    />
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Checkbox
                          checked={invoiceConfig?.ic_is_sync_note_to_supplier}
                          onChange={(e) =>
                            setInvoiceConfig((prev) => ({
                              ...prev,
                              ic_is_sync_note_to_supplier: e.target.checked,
                            }))
                          }
                        />
                      }
                      label="Đẩy ghi chú phiếu qua nhà cung cấp hóa đơn"
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Box>
                <Button
                  margin="dense"
                  variant="contained"
                  color="primary"
                  onClick={handleSaveConfigEInvoice}
                >
                  Lưu
                </Button>
              </Box>
            </Container>
          )}

          <Dialog open={openEditConfigModal} maxWidth="sm" fullWidth>
            <DialogTitle>Cấu hình nhà cung cấp hoá đơn</DialogTitle>
            <DialogContent>
              <TextField
                margin="dense"
                label="Số bắt đầu Mã CQT"
                type="number"
                fullWidth
                variant="outlined"
                value={iscBeginNumCQT}
                onChange={(e) => setIscBeginNumCQT(e.target.value)}
                size="small"
                required
              />
              <Autocomplete
                fullWidth
                options={allSuppliers}
                getOptionLabel={(option) => option.name || ""}
                value={selectedSupplierConfig}
                onChange={(event, newValue) => {
                  setSelectedSupplierConfig(newValue);
                  selectedSupplierConfigOnChange(newValue);
                }}
                filterOptions={(x) => x}
                loading={loadingSuppliers}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="dense"
                    label="Nhà cung cấp hoá đơn điện tử(*)"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingSuppliers ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                size="small"
              />
              <TextField
                margin="dense"
                label="Diễn giải"
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                value={iscDescription}
                onChange={(e) => setIscDescription(e.target.value)}
                size="small"
              />
              {selectedSupplierConfig && eInvoiceConfigFields?.length > 0 && (
                <Box>
                  <Typography variant="subtitle1" sx={{ mt: 1 }}>
                    Thông tin cấu hình chi tiết:
                  </Typography>
                  {isLoadingConfig ? (
                    <p>Đang tải cấu hình...</p>
                  ) : (
                    eInvoiceConfigFields.map((field) => {
                      let value = eInvoiceConfigData[field.parameterName];
                      if (!field.isHidden)
                        return (
                          <TextField
                            key={field.parameterName}
                            margin="dense"
                            id={field.parameterName}
                            label={`${field.fieldName}${
                              field.isRequired ? " (*)" : ""
                            }`}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={value}
                            onChange={(e) =>
                              handleEInvoiceConfigChange(
                                field.parameterName,
                                e.target.value,
                              )
                            }
                            size="small"
                          />
                        );
                    })
                  )}
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfigEInvoice} color="primary">
                Hủy
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={loading}
                onClick={handleSaveSupplierConfigEInvoice}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Lưu"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          <ConfirmDialog
            open={confirmDialogState.open}
            title={confirmDialogState.title}
            content={confirmDialogState.content}
            onConfirm={confirmDialogState.onConfirm}
            onClose={confirmDialogState.onClose}
          />
        </Box>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default DataConfigPage;
